import React from 'react';
import { FileText, ClipboardList, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Section Navigation for 1-column mode
 * Vertical sticky sidebar on the left to jump between Input and Output sections
 */
const SectionNav = ({ activeSection = 'input', onSectionChange, hasOutput = false }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Offset for sticky header
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      if (onSectionChange) {
        onSectionChange(sectionId);
      }
    }
  };

  return (
    <div className="fixed left-4 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-3">
      {/* Your Notes Button */}
      <Button
        variant={activeSection === 'input-section' ? 'default' : 'outline'}
        size="sm"
        onClick={() => scrollToSection('input-section')}
        className="flex flex-col items-center gap-1 h-auto py-3 px-3 w-16 shadow-lg border-2"
        data-testid="nav-input-section"
      >
        <FileText className="w-5 h-5" />
        <span className="text-[10px] leading-tight text-center">Notes</span>
        <ChevronRight className="w-3 h-3" />
      </Button>
      
      {/* Your Documents Button */}
      <Button
        variant={activeSection === 'output-section' ? 'default' : 'outline'}
        size="sm"
        onClick={() => scrollToSection('output-section')}
        className={`flex flex-col items-center gap-1 h-auto py-3 px-3 w-16 shadow-lg border-2 ${!hasOutput ? 'opacity-60' : ''}`}
        data-testid="nav-output-section"
      >
        <ClipboardList className="w-5 h-5" />
        <span className="text-[10px] leading-tight text-center">Docs</span>
        <ChevronRight className="w-3 h-3" />
      </Button>
      
      {/* Jump label */}
      <div className="text-[9px] text-muted-foreground text-center mt-1 opacity-70">
        Jump
      </div>
    </div>
  );
};

export default SectionNav;
